var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM26 16.9571V24.926C26 25.0541 25.5611 24.9949 25.2567 24.9537H25.2567C25.1448 24.9386 25.051 24.926 25.0039 24.926H22.0156C21.9692 24.926 21.8762 24.9385 21.765 24.9536C21.4607 24.9947 21.0195 25.0543 21.0195 24.926V17.9532C21.0195 16.223 20.5762 14.9649 19.0273 14.9649C17.8439 14.9649 17.3449 16.1851 17.0351 16.9571C16.9781 17.2867 16.9781 17.6236 17.0351 17.9532V24.926H13.0506C13.0596 23.1748 13.0865 13.9688 13.0506 11.9766H17.0351V13.9688C17.4642 13.3146 18.0589 12.7856 18.7588 12.4357C19.4586 12.0858 20.2386 11.9274 21.0195 11.9766C23.8345 11.9766 26 13.0046 26 16.9571ZM6.07792 24.926H10.0623V11.9766H6.07792V24.926ZM10.0622 7.99221C10.0622 9.09247 9.17029 9.98442 8.07003 9.98442C6.96976 9.98442 6.07782 9.09247 6.07782 7.99221C6.07782 6.89194 6.96976 6 8.07003 6C9.17029 6 10.0622 6.89194 10.0622 7.99221Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.d25ff6dd249f2f14f612cd4cf8c43e3b.svg";
export { ForwardRef as ReactComponent };